import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { API_CONSTANTS, CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';
import { LoggerService } from '@wdpr/ra-angular-logger';
import getApiBase from '@finder/shared/utils/string/getApiBase';
import { ConfigService } from '@finder/core/config.service';
import { MyPlan } from '@finder/shared/components/my-plans-modal/my-plan.class';

const apiUrlKey = CONFIG_CONSTANTS.apiUrlKey;
const defaultVersionKey = CONFIG_CONSTANTS.defaultVersionKey;

const {
    createPersonalScheduleItemEndpoint,
    friendsAndFamilyEndpoint,
    diningAvailabilityCalendarDaysEndpoint,
} = API_CONSTANTS;

const loggerBaseMessage = 'KEYRING SERVICE';

@Injectable({
    providedIn: 'root'
})
export class KeyringService {

    isLoading = false;

    constructor(
        private config: ConfigService,
        private http: HttpClient,
        private logger: LoggerService
    ) { }

    getFnFList(swid): Observable<any> {
        const url = this.getFnfUrl(swid);
        this.isLoading = true;

        return this.http.get(url)
            .pipe(
                finalize(() => this.isLoading = false),
                catchError((error) => {
                    this.logger.error(
                        `${loggerBaseMessage} FRIENDS AND FAMILY - RETRIEVE FAILED. Reason: ${error.status}|${error.message}`
                    );

                    return throwError(() => new Error(error));
                })
            );
    }

    createPersonalScheduleItem(plan: MyPlan, entityId): Observable<any> {
        const url = this.getCreatePersonalScheduleItemUrl(entityId);

        return this.http.post(url, plan)
            .pipe(
                catchError((error) => {
                    this.logger.error(
                        `${loggerBaseMessage} PERSONAL SCHEDULE ITEM - CREATE FAILED. Reason: ${error.message}`
                    );

                    return throwError(() => new Error(error));
                })
            );
    }

    getDiningAvailabilityCalendarDays(swid: string, maxDays: number, maxAdditionalDays: number): Observable<any> {
        const url = this.getDiningAvailabilityCalendarDaysUrl(swid, maxDays, maxAdditionalDays);

        return this.http.get(url)
            .pipe(
                finalize(() => this.isLoading = false),
                catchError((error) => {
                    this.logger.error(
                        `${loggerBaseMessage} ITINERARY ITEMS ALT - RETRIEVE FAILED. Reason: ${error.status}|${error.message}`
                    );

                    return throwError(() => new Error(error));
                })
            );
    }

    private getFnfUrl(swid) {
        const keyringBaseUrl = this.getKeyringBaseUrl(friendsAndFamilyEndpoint);

        return `${keyringBaseUrl}/${swid}`;
    }

    private getCreatePersonalScheduleItemUrl(entityId) {
        const keyringBaseUrl = this.getKeyringBaseUrl(createPersonalScheduleItemEndpoint);

        return `${keyringBaseUrl}/${entityId}`;
    }

    private getDiningAvailabilityCalendarDaysUrl(swid: string, maxDays: number, maxAdditionalDays: number) {
        const keyringBaseUrl = this.getKeyringBaseUrl(diningAvailabilityCalendarDaysEndpoint);

        return `${keyringBaseUrl}/${swid}/${maxDays}/${maxAdditionalDays}`;
    }

    private getKeyringBaseUrl(endpoint) {
        const baseUrl = this.config.getValue(apiUrlKey);
        const version = this.config.getValue(defaultVersionKey);

        const apiBase = getApiBase(baseUrl, version);
        const siteId = this.config.getValue('siteId');

        return `${apiBase}/${endpoint}/${siteId}`;
    }
}
